export default "__VITE_ASSET__ooBy6M2g__"